import type { PersonDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getPersonDetails(personId: string): Promise<PersonDetailed> {
  return requestApiJsonOrThrow<PersonDetailed>(`admin/people/${personId}`)
}

export const personDetailsQuery = (personId: string) => ({
  queryKey: ['person', personId],
  queryFn: () => getPersonDetails(personId),
})
